// frontend/src/components/InfraAppTypeForm.js
import React from 'react';
import {OverlayTrigger, Popover} from "react-bootstrap";

const popoverInfraAppVersion = (
    <Popover id="popover-basic">
        <Popover.Body>
            Version of Infra App to deploy. This field is mandatory <br/><br/>
            You have to enter the exact version of Infrastructure App to deploy.
        </Popover.Body>
    </Popover>
);

const InfraAppTypeForm = ({
    currentPath,
    versionFields,
    handleVersionChange,
    triggerUpdateAppPipeline,
    triggerArgoAppUpdatePipeline,
    pipelineState,
    actionInProgress,
    goBack
}) => (
    <div className="card shadow-sm border-0">
        <div className="p-3 border-bottom bg-white">
            <div className='d-flex flex-row align-items-center gap-3'>
                {currentPath && (
                    <button className="btn btn-outline-secondary btn-sm d-flex align-items-center" type="button" onClick={goBack}>
                        <i className="bi bi-arrow-left me-2"></i>
                        Back
                    </button>
                )}
                <div>
                    <h4 className="h5 mb-0 text-dark">
                        <i className="bi bi-server me-2 text-secondary"></i>
                        Infra App: {currentPath.split('/').pop()}
                    </h4>
                    <small className="text-muted">{currentPath}</small>
                </div>
            </div>
        </div>
        <div className="card-body p-4">
            <div className="row">
                {/* Deploy Update Section */}
                <div className="col-lg-6 mb-4">
                    <div className="card border-0 bg-light h-100">
                        <div className="card-body">
                            <h5 className="card-title">
                                <i className="bi bi-upload me-2 text-primary"></i>
                                Deploy Update
                            </h5>
                            <p className="text-muted small mb-4">Monitor the pipeline closely to ensure the update is operational.</p>
                            
                            <div className="mb-3">
                                <label className="form-label fw-bold">
                                    Infra App Version:
                                    <OverlayTrigger trigger="hover" placement="right" overlay={popoverInfraAppVersion}>
                                        <i className="bi bi-question-circle ms-2 text-muted"></i>
                                    </OverlayTrigger>
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={versionFields.infraAppVersion}
                                    onChange={(e) => handleVersionChange("infraAppVersion", e.target.value)}
                                    placeholder="Enter Infra App Version"
                                />
                            </div>
                            
                            <button
                                className={`btn w-100 ${
                                    pipelineState === "idle"
                                        ? "btn-primary"
                                        : pipelineState === "loading"
                                            ? "btn-warning"
                                            : pipelineState === "success"
                                                ? "btn-success"
                                                : "btn-danger"
                                } d-flex align-items-center justify-content-center`}
                                onClick={triggerUpdateAppPipeline}
                                disabled={pipelineState === "loading"}
                            >
                                {pipelineState === "loading" ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Triggering...
                                    </>
                                ) : pipelineState === "success" ? (
                                    <>
                                        <i className="bi bi-check-circle-fill me-2"></i>
                                        Success
                                    </>
                                ) : pipelineState === "failed" ? (
                                    <>
                                        <i className="bi bi-exclamation-circle-fill me-2"></i>
                                        Failed
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-play-circle me-2"></i>
                                        Trigger Pipeline
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Actions Section */}
                <div className="col-lg-6 mb-4">
                    <div className="card border-0 bg-light h-100">
                        <div className="card-body">
                            <h5 className="card-title">
                                <i className="bi bi-tools me-2 text-primary"></i>
                                Actions
                            </h5>
                            <p className="text-muted small mb-4">One rule: If you wonder what it's for, move along!</p>
                            
                            {!actionInProgress ? (
                                <div className="d-grid gap-2">
                                    <button 
                                        className="btn btn-outline-info d-flex align-items-center justify-content-center"
                                        type="button"
                                        onClick={triggerArgoAppUpdatePipeline}
                                    >
                                        <i className="bi bi-arrow-clockwise me-2"></i> 
                                        Argo App Update
                                    </button>
                                </div>
                            ) : (
                                <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2 text-muted">Processing...</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default InfraAppTypeForm;
